/**
 * Loading skeleton for wizard step content.
 * Displays a content-shaped placeholder while step content is loading via Suspense.
 */

import { Skeleton } from '@/components/ui/skeleton';
import { STEP_CONTENT_WITH_PAGINATION_HEIGHT_CLASS } from '@/sections/attacks/attackPaths/components/wizards/constants';

export function StepLoadingSkeleton() {
  return (
    <Skeleton
      shape="block"
      className={STEP_CONTENT_WITH_PAGINATION_HEIGHT_CLASS}
    />
  );
}
